import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class BusyProvider {

  private busy = new Subject<any>();
    
  constructor() { }
  
  showBusyIndicator() {
      this.busy.next("show");
  }
  
  hideBusyIndicator() {
      this.busy.next("hide");
  }

  getBusyIndicator(): Observable<any> {
      return this.busy.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/service/busy.service.ts